import React from "react";
import useGlobalStore from "../stores/globalStore";
import Loader from "./Loader";

export default function OrderForm({ isNaForm }) {
  // Form state
  const {
    nameRef,
    personalnumberRef,
    addressRef,
    postnumberRef,
    cityRef,
    emailRef,
    phoneRef,
    secondaddressRef,
    startDateInternetRef,
    startDateTvRef,
    messageRef,
    iAcceptPrivacy,
    iAcceptedTerms,

    selectedTvPackages,
    selectedTvEquipment,
    selectedBroadband,
    selectedBroadbandEquipment,
    selectedTvBasePackage,
    shippingOptions,
    selectedShipping,
    setSelectedShipping,
    setPersonalNumber,
    setName,
    setAddress,
    setPostnumber,
    setCity,
    setEmail,
    setPhone,
    setSecondaddress,
    setStartDateInternet,
    setStartDateTv,
    setMessage,
    setIAcceptPrivacy,
    setIAcceptedTerms,
    isSending,
  } = useGlobalStore((state) => state);

  return !isSending ? (
    isNaForm ? (
      <div className="tel-pt-order-form">
        <form className="tel-pt-order-form__form">
          <label className="tel-pt-order-form__name">
            <span>Namn</span>
            <input
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="*För- & efternamn"
              value={nameRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__email">
            <span>E-post</span>
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="*E-postadress"
              value={emailRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__phone">
            <span>Mobilnummer</span>
            <input
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              placeholder="*Mobilnummer"
              value={phoneRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__address">
            <span>Väg-/gatunamn, husnummer, lägenhet...</span>
            <input
              onChange={(e) => setAddress(e.target.value)}
              type="text"
              placeholder="*Väg-/gatunamn, husnummer, lägenhet..."
              value={addressRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__postnumber">
            <span>Postnummer</span>
            <input
              onChange={(e) => setPostnumber(e.target.value)}
              type="text"
              placeholder="*Postnummer"
              value={postnumberRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__city">
            <span>Ort</span>
            <input onChange={(e) => setCity(e.target.value)} type="text" placeholder="*Ort" value={cityRef} required />
          </label>

          <label className="tel-pt-order-form__privacy">
            <input
              type="checkbox"
              name="privacy"
              id="privacy"
              onClick={() => setIAcceptPrivacy(!iAcceptPrivacy)}
              checked={iAcceptPrivacy}
            />
            Jag samtycker till att Teleservice behandlar personuppgifter om mig i enlighet med personupgiftspolicy.
          </label>
          <label className="tel-pt-order-form__privacy">
            <input
              type="checkbox"
              name="privacy"
              id="privacy"
              checked={iAcceptedTerms}
              onClick={() => setIAcceptedTerms(!iAcceptedTerms)}
            />
            Jag har läst och accepterar de <a href="https://www.teleservice.net/wp-content/uploads/2020/05/AV-Konsument-2019-09-20-slutgiltig.pdf" target="_blank">allmänna villkoren.</a>
          </label>
        </form>
      </div>
    ) : (
      <div className="tel-pt-order-form">
        <form className="tel-pt-order-form__form">
          <label className="tel-pt-order-form__personalnumber">
            <span>Personnummer</span>
            <input
              onChange={(e) => setPersonalNumber(e.target.value)}
              type="text"
              placeholder="*Personnummer"
              value={personalnumberRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__name">
            <span>Namn</span>
            <input
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="*För- & efternamn"
              value={nameRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__address">
            <span>Väg-/gatunamn, husnummer, lägenhet...</span>
            <input
              onChange={(e) => setAddress(e.target.value)}
              type="text"
              placeholder="*Väg-/gatunamn, husnummer, lägenhet..."
              value={addressRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__postnumber">
            <span>Postnummer</span>
            <input
              onChange={(e) => setPostnumber(e.target.value)}
              type="text"
              placeholder="*Postnummer"
              value={postnumberRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__city">
            <span>Ort</span>
            <input onChange={(e) => setCity(e.target.value)} type="text" placeholder="*Ort" value={cityRef} required />
          </label>

          <label className="tel-pt-order-form__email">
            <span>E-post</span>
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="*E-postadress"
              value={emailRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__phone">
            <span>Mobilnummer</span>
            <input
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              placeholder="*Mobilnummer"
              value={phoneRef}
              required
            />
          </label>

          <label className="tel-pt-order-form__second-address">
            <span>Fastighetsadress för tjänster (om annan än ovan)</span>
            <input
              onChange={(e) => setSecondaddress(e.target.value)}
              type="text"
              placeholder="Fastighetsadress för tjänster (om annan än ovan)"
              value={secondaddressRef}
            />
          </label>

          <label className="tel-pt-order-form__start-date-internet">
            <span>Startdatum - bredband</span>
            <input
              onChange={(e) => setStartDateInternet(e.target.value)}
              type="text"
              placeholder="Startdatum - bredband"
              onFocus={(e) => (e.target.type = "date")}
              disabled={selectedBroadband.id === 2222222}
              value={startDateInternetRef}
            />
          </label>

          <label className="tel-pt-order-form__start-date-tv">
            <span>Startdatum - tv</span>
            <input
              onChange={(e) => setStartDateTv(e.target.value)}
              type="text"
              placeholder="Startdatum - tv"
              onFocus={(e) => (e.target.type = "date")}
              value={startDateTvRef}
              disabled={selectedTvPackages && selectedTvPackages[0].id === 3333333}
            />
          </label>

          <label className="tel-pt-order-form__message">
            <span>Meddelande</span>
            <textarea
              onChange={(e) => setMessage(e.target.value)}
              type="date"
              placeholder="*Meddelande - här kan du tex. ange information om önskemål kring tillvalskanaler, telefoni eller om du önskar hjälp med installation."
              value={messageRef}
              required
            />
          </label>

          {(selectedTvEquipment[0].id != 5555555 || selectedBroadbandEquipment[0].id != 4444444) && (
            <div className="tel-pt-order-form__shipping">
              <span>Frakt</span>
              {shippingOptions &&
                shippingOptions.map((option) => (
                  <label
                    className={`${option.title === selectedShipping?.title ? "selected" : ""}`}
                    onClick={() => setSelectedShipping(option)}
                    key={option.id}
                  >
                    <input type="radio" name={option.title} id={option.title} />
                    {option.title} - {option.price}kr
                  </label>
                ))}
            </div>
          )}

          <label className="tel-pt-order-form__privacy">
            <input
              type="checkbox"
              name="privacy"
              id="privacy"
              checked={iAcceptPrivacy}
              onClick={() => setIAcceptPrivacy(!iAcceptPrivacy)}
            />
            Jag samtycker till att Teleservice behandlar personuppgifter om mig i enlighet med personupgiftspolicy.
          </label>
          <label className="tel-pt-order-form__privacy">
            <input
              type="checkbox"
              name="privacy"
              id="privacy"
              checked={iAcceptedTerms}
              onClick={() => setIAcceptedTerms(!iAcceptedTerms)}
            />
            Jag har läst och accepterar de <a href="https://www.teleservice.net/wp-content/uploads/2020/05/AV-Konsument-2019-09-20-slutgiltig.pdf" target="_blank">allmänna villkoren.</a>
          </label>
        </form>
      </div>
    )
  ) : (
    <Loader />
  );
}
